import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  PayrollRunSelectionAction,
  PayrollRunSelectionComponent,
  PayrollRunSelectionDownloadList,
} from '../../shared/payroll-run-selection/payroll-run-selection.component';

@Component({
  selector: 'app-selectpayrolljournal',
  imports: [PayrollRunSelectionComponent],
  templateUrl: './selectpayrolljournal.component.html',
  styleUrl: './selectpayrolljournal.component.scss',
})
export class SelectpayrolljournalComponent {
  private router = inject(Router);

  private readonly navigationState =
    this.router.getCurrentNavigation()?.extras?.state ?? history.state;
  readonly initialOpdrachtgeverId = (this.navigationState?.['opdrachtgeverId'] as string) ?? null;
  readonly initialInstellingId = (this.navigationState?.['instellingId'] as string) ?? null;

  onCreate(action: PayrollRunSelectionAction): void {
    this.router.navigate(
      ['/proces/export/exportgeneralledger/creategeneralledger', action.importRunId],
      {
        state: {
          opdrachtgeverName: action.opdrachtgeverName,
          opdrachtgeverId: action.opdrachtgeverId,
          instellingId: action.instellingId,
        },
      },
    );
  }

  onDownloadList(selection: PayrollRunSelectionDownloadList): void {
    this.router.navigate(['/proces/export/exportgeneralledger/downloadgeneralledger'], {
      queryParams: {
        institutionId: selection.instellingId,
        bookingYear: selection.bookingYear,
        bookingPeriod: selection.bookingPeriod,
        opdrachtgeverId: selection.opdrachtgeverId,
      },
    });
  }
}
